var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sim"},[_c('div',{staticClass:"sim-ct"},[_c('ul',_vm._l((_vm.sun),function(item){return _c('li',[_c('h5',[_vm._v(_vm._s(item.title))]),_c('p',[_vm._v(_vm._s(item.num)+" 產品")])])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }